"use client";

import { useState } from "react";
import { Button } from "../../shared";
import { Box, Card, IconButton, Radio, RadioGroup, Sheet, Textarea, Typography } from "@mui/joy";
import { X, MessageSquare } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const MotionCard = motion(Card);
const MotionDiv = motion.div;

export default function FeedbackWidget() {
    const [open, setOpen] = useState(false);

    const toggleWidget = () => setOpen((prev) => !prev);
    const closeWidget = () => setOpen(false);

    return (
        <Box position="fixed" sx={{ right: 16, bottom: 16, zIndex: 9999 }}>
            <AnimatePresence mode="wait">
                {open ? (
                    <MotionCard
                        key="feedback-form"
                        sx={{ width: 350 }}
                        initial={{ opacity: 0, y: 200, scale: 0.1, x: 150 }}
                        animate={{ opacity: 1, y: 0, scale: 1, x: 0 }}
                        exit={{ opacity: 0, y: 200, x: 150, scale: 0.1 }}
                        transition={{ duration: 0.25 }}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography level="title-lg">Rate your experience</Typography>
                            <IconButton color="neutral" variant="plain" size="sm" onClick={closeWidget}>
                                <X size={16} />
                            </IconButton>
                        </Box>

                        <RadioGroup defaultValue="" size="lg" sx={{ gap: 1.5 }} orientation="horizontal">
                            {["😕 Bad", "🙂 Decent", "❤️ Love it"].map((value) => (
                                <Sheet
                                    key={value}
                                    sx={{
                                        p: 1,
                                        flex: 1,
                                        px: 2,
                                        borderRadius: "md",
                                        boxShadow: "sm",
                                    }}
                                >
                                    <Radio
                                        label={value}
                                        overlay
                                        disableIcon
                                        value={value}
                                        slotProps={{
                                            label: ({ checked }) => ({
                                                sx: {
                                                    fontWeight: "md",
                                                    fontSize: "14px",
                                                    color: checked ? "text.primary" : "text.secondary",
                                                },
                                            }),
                                            action: ({ checked }) => ({
                                                sx: (theme) => ({
                                                    ...(checked && {
                                                        "--variant-borderWidth": "2px",
                                                        "&&": {
                                                            borderColor: theme.vars.palette.primary[500],
                                                        },
                                                    }),
                                                }),
                                            }),
                                        }}
                                    />
                                </Sheet>
                            ))}
                        </RadioGroup>

                        <Textarea minRows={3} sx={{ mt: 2 }} placeholder="Tell us more" />

                        <Box mt={2}>
                            <Button>Submit your feedback</Button>
                        </Box>
                    </MotionCard>
                ) : (
                    <MotionDiv
                        key="feedback-button"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{ duration: 0.25 }}
                    >
                        <IconButton color="primary" variant="solid" size="lg" onClick={toggleWidget}>
                            <MessageSquare size={20} />
                        </IconButton>
                    </MotionDiv>
                )}
            </AnimatePresence>
        </Box>
    );
}
